import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

import I18n from "./components/I18n.vue";
import { Store } from "../store";
Vue.component("i18n", I18n);

let i18nModuleBasePaths = [] as string[]; //{} as { [moduleName: string]: { [locale: string]: any } };

export const SupportedLocales: string[] = ["en", "nl", "fr", "de"];
export const locale = Store.get<string>("l") || SupportedLocales[0];

export const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: SupportedLocales[0],
  messages: {}, //{ [locale]: require(`@/locales/${locale}.json`) }
}) as VueI18n;

export async function setLocale(value: string, soft = false) {
  // bind i18n.locale after import && setLocaleMessage to avoid vue-i18 warn when switching lang
  // [vue-i18n] Cannot translate the value of keypath '...'. Use the value of keypath as default.
  // see doc: https://kazupon.github.io/vue-i18n/guide/lazy-loading.html
  // i18n.locale = resolveLocale(value, soft);
  const lang = resolveLocale(value, soft);

  let messages = {};
  for (const mod of i18nModuleBasePaths) {
    const res = await import(/* webpackChunkName: "i18n-[request]" */ `@/@${mod}/i18n/${lang}.json`);
    messages = Object.assign(messages, res.default);
  }

  i18n.setLocaleMessage(lang, messages);
  i18n.locale = lang;
}

export function initI18n(modules: { name: string; shared?: boolean; supportedLocales?: string[] }[]): VueI18n {
  i18nModuleBasePaths = [
    "shell",
    ...modules.map(m => {
      if (m.shared) {
        return `shared/${m.name}`;
      } else {
        return `modules/${m.name}`;
      }
    }),
  ];

  modules
    .filter(m => !!m.supportedLocales)
    .map(m => m.supportedLocales!)
    .forEach(moduleLocales => {
      const unsupportedLocalesOfModule = SupportedLocales.filter(l => !moduleLocales.includes(l));
      unsupportedLocalesOfModule.forEach(l => {
        SupportedLocales.splice(SupportedLocales.indexOf(l), 1);
      });
    });

  return i18n;
}

function resolveLocale(requestedLocale: string, soft: boolean): string {
  if (soft) {
    return Store.get<string>("l") || requestedLocale || ifSupported(navigator.language) || SupportedLocales[0];
  }

  let value = ifSupported(requestedLocale);

  if (!value && value == "de" && SupportedLocales.includes("fr")) {
    value = "fr";
  }

  value = value || ifSupported(navigator.language) || Store.get<string>("l") || SupportedLocales[0];

  Store.set("l", value);
  return value;
}

function ifSupported(locale: string): string | null {
  const v = (locale || "").substr(0, 2);
  return SupportedLocales.includes(v) ? v : null;
}
